export function usuariosInRequest(params = {}) {
  return {
    type: '@usuario/USUARIOS_IN_REQUEST',
    payload: { params },
  };
}

export function findUsuario(idusuario) {
  return {
    type: '@usuario/FIND_USUARIO',
    payload: { idusuario },
  };
}

export function failedRequest() {
  return {
    type: '@usuario/FAILED_REQUEST',
  };
}

export function deleteUsuario(idusuario, params) {
  return {
    type: '@usuario/DELETE_USUARIO',
    payload: { idusuario, params },
  };
}

export function updateUsuario(usuario, params) {
  return {
    type: '@usuario/UPDATE_USUARIO',
    payload: { usuario, params },
  };
}

export function storeUsuario(usuario, params) {
  return {
    type: '@usuario/STORE_USUARIO',
    payload: { usuario, params },
  };
}

export function successInRequest(
  usuarios,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@usuario/SUCCESS_IN_REQUEST',
    payload: { usuarios, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(usuario) {
  return {
    type: '@usuario/SUCCESS_REQUEST',
    payload: { usuario },
  };
}

export function successRemove(params) {
  return {
    type: '@usuario/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@usuario/RECORD_FILTERING',
    payload: { params },
  };
}
